module.exports = __webpack_public_path__ + "assets/img/pie-middle.c708daa3.svg";